import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert
} from '@mui/material';
import { useSnackbar } from 'notistack';
import axios from 'axios';

interface DeleteAdminDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  adminId: number | null;
  adminName: string;
}

const DeleteAdminDialog: React.FC<DeleteAdminDialogProps> = ({
  open,
  onClose,
  onSuccess,
  adminId,
  adminName
}) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleDelete = async () => {
    if (!adminId) return;

    setError(null);
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('인증 토큰 없음');
      }

      await axios.delete(`/api/users/${adminId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      enqueueSnackbar('관리자가 삭제 완료', { variant: 'success' });
      onSuccess();
      onClose();
    } catch (error: any) {
      console.error('관리자 삭제 오류:', error);
      setError(error.response?.data?.detail || '관리자 삭제 중 오류 발생');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>관리자 삭제</DialogTitle>
      <DialogContent>
        <DialogContentText>
          관리자 "{adminName}" 삭제 확인
          이 작업은 되돌리기 불가
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          취소
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="error"
          disabled={loading}
        >
          삭제
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAdminDialog; 